import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Youtube, Facebook, Linkedin, ArrowRight } from 'lucide-react';

const TikTokIcon = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.6 6.3a5.6 5.6 0 0 1-3.4-1.2 5.4 5.4 0 0 1-2-3.6V1h-3.5v13.8a2.9 2.9 0 1 1-2.1-2.8V8.5a6.4 6.4 0 1 0 5.6 6.3V9A9 9 0 0 0 19.6 10V6.3z" />
  </svg>
);
import { contactInfo } from '../data/mockData';

const CAL_URL = 'https://calendly.com/thecollinsacademynew/30min';

const Footer = () => {
  return (
    <footer className="tcf-footer" data-testid="tcf-footer">
      <div className="tcf-footer-inner">
        <div className="tcf-footer-top">
          <div className="tcf-footer-brand">
            <img
              src="/logo.png"
              alt="The Collins Academy"
              className="tcf-footer-logo"
            />
            <p className="tcf-footer-tagline">
              Credit. Capital. AI. The room. Founder-led systems for real wealth — not another
              guru playbook.
            </p>
            <div className="tcf-footer-social">
              <a
                href="https://www.facebook.com/thereallamarquscollins"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://www.youtube.com/@the.collinsacademy"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                data-testid="footer-youtube"
              >
                <Youtube size={18} />
              </a>
              <a
                href="https://www.linkedin.com/in/lamarquscollins/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://www.tiktok.com/@thereallamarquscollins"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                data-testid="footer-tiktok"
              >
                <TikTokIcon size={18} />
              </a>
            </div>
          </div>

          <div className="tcf-footer-col">
            <h4>Contact</h4>
            <a href={`mailto:${contactInfo.email}`} className="tcf-footer-link">
              <Mail size={14} /> <span>{contactInfo.email}</span>
            </a>
            <a href={`tel:${contactInfo.phone}`} className="tcf-footer-link">
              <Phone size={14} /> <span>{contactInfo.phone}</span>
            </a>
            <span className="tcf-footer-link tcf-footer-link-static">
              <MapPin size={14} /> <span>{contactInfo.location}</span>
            </span>
          </div>

          <div className="tcf-footer-col tcf-footer-cta-col">
            <h4>Ready to move</h4>
            <p className="tcf-footer-cta-copy">
              Grab a private 30-minute strategy call with the Collins team.
            </p>
            <a
              href={CAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="tcf-btn tcf-btn-primary"
              data-testid="footer-cta"
            >
              Book a Call <ArrowRight size={16} />
            </a>
          </div>
        </div>

        <div className="tcf-footer-disclaimer">
          The Collins Academy provides education, done-for-you services, and strategic consulting.
          Results depend on individual effort and circumstances. Statements about credit outcomes,
          business funding, and income potential are not guarantees.
        </div>

        <div className="tcf-footer-bottom">
          <span>© {new Date().getFullYear()} The Collins Academy. All rights reserved.</span>
          <span className="tcf-footer-legal">
            <Link to="/privacy-policy">Privacy</Link>
            <span className="tcf-footer-dot">·</span>
            <Link to="/terms-of-service">Terms</Link>
            <span className="tcf-footer-dot">·</span>
            <Link to="/compliance">Compliance</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
